var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import Styles from './texts-styles.scss';
import { BookIcon, ButtonBack, ButtonKVBase } from '@/presentation/components';
import { useRecoilState } from 'recoil';
import { lessonState } from '@/presentation/pages/lessons/components/atoms';
import { useNavigate, useParams } from 'react-router';
import useLessons from '@/presentation/hooks/use-lessons';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import WordReplacerV2 from '@/presentation/pages/module-detail/components/custom-text/wordReplacerV2';
import useUserSesssion from '@/presentation/hooks/use-user-session';
const Texts = ({ manageProgressService, loadLessons, loadKeywords }) => {
    var _a, _b, _c;
    const [state] = useRecoilState(lessonState);
    const { user } = useUserSesssion();
    const { idModule, idText } = useParams();
    const moduleDashboardPath = ((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.description) === 'Teacher' ? '/teacher-dashboard/modules' : '/student-dashboard/my-modules';
    const { showCustomError } = useCustomToast({
        containerId: 'Text-container'
    });
    const navigate = useNavigate();
    const [body, setBody] = useState(null);
    const [keywords, setKeywords] = useState([]);
    const { menuItemsState } = useLessons({ manageProgressService, Styles, loadLessons });
    useEffect(() => {
        try {
            if (idText) {
                const findTextById = state === null || state === void 0 ? void 0 : state.lesson.lessonsTexts.find(text => (text === null || text === void 0 ? void 0 : text.id) === Number(idText));
                if (findTextById)
                    setBody(findTextById);
            }
        }
        catch (error) {
            console.log(error);
            showCustomError('Error', 'Error loading text');
        }
    }, [state, idText]);
    const getKeywords = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield loadKeywords.all();
            if (response) {
                setKeywords(response);
            }
        }
        catch (error) {
            console.log(error);
            showCustomError('Error', 'Error loading keywords');
        }
    });
    useEffect(() => {
        getKeywords();
    }, []);
    if (state.isLoading || !state.lesson)
        return null;
    return (React.createElement("div", { className: Styles.videoWrap, id: "text-container" },
        React.createElement("div", { className: Styles.title },
            React.createElement(ButtonBack, { text: "Module", btnBackgroundGradient: "transparent", onClick: () => {
                    navigate(`${moduleDashboardPath}/${idModule}`);
                } }),
            React.createElement("div", { className: Styles.texts },
                React.createElement("span", null,
                    "lesson ", (_b = state === null || state === void 0 ? void 0 : state.lesson) === null || _b === void 0 ? void 0 :
                    _b.id),
                React.createElement("h3", null, (_c = state === null || state === void 0 ? void 0 : state.lesson) === null || _c === void 0 ? void 0 : _c.name))),
        React.createElement("div", { className: Styles.content },
            React.createElement("div", { className: Styles.header },
                React.createElement("span", { className: Styles.icon },
                    React.createElement(BookIcon, null)),
                React.createElement("div", { className: Styles.headerTexts },
                    React.createElement("span", null, "Text"),
                    state && (state === null || state === void 0 ? void 0 : state.lesson) && body && React.createElement("h3", null, (body === null || body === void 0 ? void 0 : body.name) || ''))),
            React.createElement("div", { className: Styles.video }, (state === null || state === void 0 ? void 0 : state.lesson) && keywords && body && React.createElement(WordReplacerV2, { input: body === null || body === void 0 ? void 0 : body.body, loadKeywords: loadKeywords })),
            React.createElement("span", { className: Styles.divider }),
            React.createElement("div", { className: Styles.buttons },
                React.createElement("div", { className: Styles.left },
                    React.createElement(ButtonBack, { btnBackgroundGradient: "white", onClick: () => {
                            if (menuItemsState) {
                                const previous = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
                                if (previous > 0) {
                                    menuItemsState[previous - 1].onClick();
                                }
                            }
                        }, text: "Previous" })),
                React.createElement("div", { className: Styles.right },
                    React.createElement("div", { className: Styles.button },
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", disabled: false, onClick: () => {
                                if (menuItemsState) {
                                    const next = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
                                    menuItemsState[next].onFinish();
                                    if (next < menuItemsState.length - 1) {
                                        menuItemsState[next + 1].onClick();
                                    }
                                }
                            } }, "Next")))))));
};
export default Texts;
